export default "/bitrix/js/ui/sign-up/dist/images/photo.svg"